/* 布局 */
//前台
import Layout from "@views/layout";

const goodspointsprogramRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
            path: "goodspointsprogram",
            name: "GOODSPOINTSPROGRAM",
            meta: {
                title: "积分项目",
                sort: 1,
            },
            component: () => import("@views/business/goodspointsprogram/index.vue"),
            redirect: {
                name: "GOODSPOINTSPROGRAM_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "GOODSPOINTSPROGRAM_LIST",
                    meta: {
                        title: "积分项目",
                        sort: 2,
                        keepAlive: true
                    },
                    component: () => import("@views/business/goodspointsprogram/list.vue"),
                },
                {
                    path: "add",
                    name: "GOODSPOINTSPROGRAM_ADD",
                    meta: {
                        title: "新增积分项目表",
                        parentPath: '/business/goodspointsprogram/list',
                        operate: true,
                    },
                    component: () => import("@views/business/goodspointsprogram/form.vue"),
                },
                {
                    path: "edit",
                    name: "GOODSPOINTSPROGRAM_EDIT",
                    meta: {
                        title: "编辑积分项目表",
                        parentPath: '/business/goodspointsprogram/list',
                        operate: true,
                    },
                    component: () => import("@views/business/goodspointsprogram/form.vue"),
                },
            ],
        },


    ],
};

export default goodspointsprogramRouter;
